



























import {
  Configuration,
  PositionQualificationOverview,
  ConferenceDoctorPositionRestControllerApi,
} from '@/types/api-docs'
import Utils from '@/utils/utils'
import { DataOptions, DataTableHeader } from 'vuetify'
import Vue from 'vue'

const positionApi = new ConferenceDoctorPositionRestControllerApi(
  new Configuration({ basePath: `${window.location.origin}` })
)

export type DataType = {
  pageName: string
  breadcrumbs: unknown[]
  overviews?: PositionQualificationOverview[]
  total?: number
  loading: boolean
  options: DataOptions
  headers: DataTableHeader[]
}

export type Meeting = {
  id?: number
  meetingName?: string
  eventDate?: string
  probablyAttend?: string
  actuallyAttend?: string
}

export default Vue.extend({
  components: {},
  data(): DataType {
    return {
      pageName: this.$route.meta.title,
      breadcrumbs: [
        {
          text: 'HOME',
          href: '/member',
        },
        {
          text: `${this.$route.meta.title}`,
          disabled: true,
        },
      ],
      overviews: [],
      total: 0,
      loading: true,
      options: {
        page: 1,
        itemsPerPage: 20,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      headers: [
        { text: 'No', value: 'id' },
        { text: '委員会名', value: 'committeeName', sortable: false },
        {
          text: '役職',
          value: 'position',
          sortable: false,
        },
        {
          text: '任期状態',
          value: 'status',
        },
        { text: '任期就任日', value: 'termDateFrom', sortable: false },
        { text: '任期満了日', value: 'termDateTo', sortable: false },
      ],
    }
  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi()
      },
      deep: true,
    },
  },
  computed: {},
  methods: {
    async getDataFromApi() {
      this.loading = true
      const { data } = await positionApi.fetchMemberPositionQualificationOverviews(
        this.options.page - 1,
        this.options.itemsPerPage,
        Utils.parseSortQueryParams(this.options)
      )
      this.overviews = data.content
      this.total = data.totalElements
      this.loading = false
      if (data.totalPages && this.options.page > data.totalPages) {
        this.options.page = data.totalPages
      }
    },
  },
})
